import type { TwMainColor } from "data/types";
import { MoodEnum } from "data/enums";

const returnMoodColor = (mood: MoodEnum): TwMainColor => {
  switch (mood) {
    case MoodEnum.AUTHENTIC:
      return "green";
    case MoodEnum.BUSINESS:
      return "blue";
    case MoodEnum.COMFORT:
      return "yellow";
    case MoodEnum.ENERGETIC:
      return "purple";
    default:
      return "red";
  }
}

export default returnMoodColor;